import { render, staticRenderFns } from "./NoMessages.vue?vue&type=template&id=d6be90f8&scoped=true"
import script from "./NoMessages.vue?vue&type=script&lang=js"
export * from "./NoMessages.vue?vue&type=script&lang=js"
import style0 from "./NoMessages.vue?vue&type=style&index=0&id=d6be90f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be90f8",
  null
  
)

export default component.exports